import htmx from 'htmx.org'
import { WidgetInstance } from 'friendly-challenge'

// Friendly Captcha on the sign up page. The form is swapped by htmx when it is
// re-rendered with errors, so the widget has to be initialized again.
const initSignUpCaptcha = (root: Node) => {
  if (!(root instanceof Element)) return

  const container = root.querySelector('.frc-captcha.signup-captcha') as HTMLElement | null
  const sitekey = container?.getAttribute('data-sitekey')
  if (!container || !sitekey) return

  new WidgetInstance(container, {
    sitekey,
    startMode: 'focus',
    doneCallback: (solution: string) => {
      const hiddenField = document.getElementById('signup_captcha_solution') as HTMLInputElement | null
      if (hiddenField) hiddenField.value = solution
    },
  })
}

htmx.onLoad(initSignUpCaptcha)
